import { createStore, filterNil, select, withProps } from '@ngneat/elf';
import {
  createRequestsStatusOperator,
  selectRequestStatus,
  updateRequestStatus,
  withRequestsStatus,
} from '@ngneat/elf-requests';
import { CompanySettings } from 'data-access';
import { map } from 'rxjs/operators';
import { Region } from 'src/app/utils/regions';
import { getUserTypeDisplayNameKey } from './get-usertype-display-name-key';
import { mapDataVersionToRegion } from './map-data-version-to-region';

interface AmsProps {
  companySettings: CompanySettings | null;
  region: Region | string;
}

const amsStore = createStore(
  { name: 'ams' },
  withProps<AmsProps>({
    companySettings: null,
    region: 'No Region',
  }),
  withRequestsStatus<'company-settings'>()
);

export const amsStoreSnapshot = () => amsStore.getValue();

export const trackAmsRequestsStatus = createRequestsStatusOperator(amsStore);

export const companySettingsStatus$ = amsStore.pipe(
  selectRequestStatus('company-settings')
);

export const companySettings$ = amsStore.pipe(
  select(({ companySettings }) => companySettings),
  filterNil()
);

export const userTypeDisplayNameKey$ = amsStore.pipe(
  select(({ companySettings }) => companySettings),
  filterNil(),
  map(({ userType }) => getUserTypeDisplayNameKey(userType ? userType : null))
);

export function updateCompanySettings(companySettings: CompanySettings) {
  amsStore.update(
    (state) => ({
      ...state,
      companySettings,
      region: mapDataVersionToRegion(companySettings.dataVersion),
    }),
    updateRequestStatus('company-settings', 'success')
  );
}

export function resetAmsStore() {
  amsStore.reset();
}
